export const LAMBDA_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3001"
    : "https://7dqktlh5adfa6lphzsmxprnngi0jmuqv.lambda-url.us-east-2.on.aws";

/** Deep link to a Contact record in Zoho CRM (org id matches server-side integrations). */
export function zohoCrmContactUrl(contactId: string): string {
  return `https://crm.zoho.com/crm/org31013314/tab/Contacts/${contactId}`;
}
